import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, formataCurrency } from './../app.config';
import { ProdutoPacote } from './produto-pacote.model';
import { NTECH_API } from '../app.api';
import { ProdutoSegmento } from './../produto-segmento/produto-segmento.model';
import { ProdutoSegmentoService } from './../produto-segmento/produto-segmento.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-produto-pacote',
  templateUrl: './produto-pacote.component.html',
  styleUrls: ['./produto-pacote.component.css']
})
export class ProdutoPacoteComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listaProdutoPacote: CustomStore;
  listaProdutoSegmento: ProdutoSegmento[] = [];
  alturaGrid = null;

  listasForm = [
    {Nome: 'listaProdutoSegmento', status: false}
  ];

  colunasGridProdutoPacote = [];

  editOptionsGridProdutoPacote = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'ProdutoPacote',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private produtoSegmentoService: ProdutoSegmentoService
  ) {

    // carrega a lista de ProdutoSegmento
    this.produtoSegmentoService.getProdutoSegmentos()
      .subscribe(produtoSegmentos => {
        this.listaProdutoSegmento = produtoSegmentos;
        this.verificarListasCarregadas('listaProdutoSegmento');
      },
      error => {
        this.verificarListasCarregadas('listaProdutoSegmento');
      }
    );

    this.listaProdutoPacote = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/produto-pacote/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/produto-pacote/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/produto-pacote/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/produto-pacote/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listasForm[0].status === true) {

      this.colunasGridProdutoPacote = [
        {
          dataField: 'Id',
          dataType: 'text',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'DescricaoProdutoPacote',
          dataType: 'text',
          caption: 'Descrição',
          validationRules: [{
            type: 'required',
            message: 'Descrição é obrigatório.'
          }]
        },
        {
          dataField: 'IdProdutoSegmento',
          caption: 'Produto Segmento',
          lookup: {
              dataSource: this.listaProdutoSegmento,
              displayExpr: 'DescricaoProdutoSegmento',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Produto Segmento é obrigatório.'
          }]
        },
        {
          dataField: 'ValorPacote',
          dataType: 'number',
          caption: 'Valor do Pacote',
          format: 'currency',
          editorOptions: { format: 'R$ #,##0.00' },
          validationRules: [{
            type: 'required',
            message: 'Valor do Pacote é obrigatório.'
          }],
          customizeText: formataCurrency
        }
      ];

      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/produto-pacote/produto-pacote.component.ts